module.exports = __webpack_public_path__ + "media/images/photos/c1-fafd680429d7ce19f5608263f2579744.jpg";